import { Navigate } from "react-router-dom";
import { isInhouse, usePlan } from "../utils/usePlan";

// Wraps a route the in-house edition doesn't have (Dashboard, Jobs, Saved, Research): in-house lands
// on People instead. Nothing renders until the plan is known, so agency users never see a redirect flash.
export function EditionGate({ children }) {
  const { features, loading } = usePlan();
  if (loading) return null;
  if (isInhouse(features)) return <Navigate to="/find-candidates" replace />;
  return children;
}
